
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import Header from "@/components/common/Header";
import SEOHead from "@/components/common/SEOHead";
import { WaitlistProvider } from "@/context/WaitlistContext";
import { useAnalytics } from "@/hooks/useAnalytics";
import HeroSection from "@/components/homepage/HeroSection";
import HowItWorksSection from "@/components/homepage/HowItWorksSection";
import HeartBehindWabisabiSection from "@/components/homepage/HeartBehindWabisabiSection";
import AboutUsSection from "@/components/homepage/AboutUsSection";
import WhyWeBuildItSection from "@/components/homepage/WhyWeBuildItSection";
import FAQSection from "@/components/homepage/FAQSection";
import AppPreviewSection from "@/components/homepage/AppPreviewSection";
import { Skeleton } from "@/components/ui/skeleton";
import FinalCTASection from "@/components/homepage/FinalCTASection";
import FooterSection from "@/components/homepage/FooterSection";


const Homepage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { trackButtonClick } = useAnalytics(); // This will also handle automatic page view tracking

  const handleWaitlistClick = () => {
    trackButtonClick('Get Started', 'homepage_hero');
    // For now, navigate to auth - can be updated to actual waitlist later
    navigate("/auth?mode=signup");
  };

  // Handle scrolling to section when navigating with hash
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1); // Remove the # symbol
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100); // Small delay to ensure DOM is ready
    }
  }, [location]);


  try {
    return (
      <WaitlistProvider>
        <SEOHead pageKey="homepage" />
        <div className="flex min-h-screen flex-col font-nunito overflow-x-hidden bg-[#F7F5F2]">
          <Header showActions={true} />
          <main className="flex-1 gap-5 md:gap-0 flex flex-col pt-16">
            <div id="home" className="transition-all duration-1000 ease-in-out">
              <HeroSection />
            </div>

            <div id="how-it-works" className="transition-all duration-1000 ease-in-out">
              <HowItWorksSection />
            </div>

            <div id="our-values" className="transition-all duration-1000 ease-in-out">
              <AboutUsSection />
            </div>

            <div className="transition-all duration-1000 ease-in-out">
              <WhyWeBuildItSection />
            </div>

            <div className="transition-all duration-1000 ease-in-out">
              <FAQSection />
            </div>

          </main>

          <div className="bg-[#F7F5F2] transition-all duration-1000 ease-in-out">
            <FooterSection />
          </div>
        </div>
      </WaitlistProvider>
    );
  } catch (error) {
    console.error("Error rendering Homepage component:", error);
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <Skeleton className="h-8 w-64 mx-auto" />
          <Skeleton className="h-4 w-80 mx-auto" />
        </div>
      </div>
    );
  }
};

export default Homepage;
